import React, {Component} from 'react'
import {Alert, Button, Icon, Input, message, Modal, Tooltip} from 'antd'
import PropTypes from 'prop-types'
import {updatePartner} from "../../../services/api/3dApi"
import {canManagePartner, getNoPermissionMessage, getPartnerErrorMessage, DISABLED_ICON_STYLE} from '../../partners/helpers/partnerPermission'

class UpdatePartner extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
            loading: false,
            error: '',
            name: this.props.name
        }
    }

    _showModal = () => {
        this.setState({
            isOpen: true,
            loading: false,
            error: ''
        })
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
            loading: false,
            error: ''
        })
    }
    _handleChangeInput = (e) => {
        const {value} = e.target

        this.setState({
            name: value
        })
    }

    _updatePartner = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {name} = this.state
            const {id} = this.props

            const {data} = await updatePartner(id, {name})

            const {success, error} = data

            if (!success) {
                this.setState({
                    loading: false,
                    error: error
                })
                return
            }

            this.setState({
                loading: false
            }, () => {
                message.success('Cập nhật tên đối tác thành công.')
                if (typeof this.props.onGetPartner === 'function') {
                    this.props.onGetPartner()
                }
                this._closeModal()
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: getPartnerErrorMessage(e, 'sửa')
            })
        }
    }

    render() {
        const {isOpen, loading, error, name} = this.state

        if (!canManagePartner()) {
            return (
                <div className="UpdatePartner">
                    <Tooltip title={getNoPermissionMessage('sửa')}>
                        <Icon type="edit" style={DISABLED_ICON_STYLE}/>
                    </Tooltip>
                </div>
            )
        }

        return (
            <div className="UpdatePartner">
                <Icon type="edit" onClick={this._showModal}/>
                <Modal
                    title="Sửa tên đối tác"
                    visible={isOpen}
                    onOk={this._createPartner}
                    onCancel={this._closeModal}
                    footer={[
                        <Button key="back" onClick={this._closeModal}>
                            Hủy
                        </Button>,
                        <Button key="submit" type="primary" loading={loading} onClick={this._updatePartner}>
                            Cập nhật
                        </Button>
                    ]}
                >
                    {error && <Alert className='mb-3' message={error} type='error'/>}

                    <label>Tên mới của đối tác</label>
                    <Input value={name || ''} onChange={this._handleChangeInput}/>
                </Modal>
            </div>
        )
    }
}

UpdatePartner.propTypes = {
    name: PropTypes.string
}

export default UpdatePartner
